import { Grid } from '@material-ui/core';
import usePermission from '../../hooks/usePermission';
import { UserPermission } from '../../enum/userPermissions';
import { useStyles, CancelButton } from './PersonalData.styles';
import { formatPhone } from '../UserProfile/helpers';

interface PersonalDataProps {
  firstName: string | undefined;
  lastName: string | undefined;
  pesel: string | undefined;
  phone: string | undefined;
  email: string | undefined;
  committee: string | undefined;
  accountTypeName: string | undefined;
  editData: () => void;
}

export default function PersonalData(props: PersonalDataProps) {
  const classes = useStyles();

  const permissionUseSelfUpdate = usePermission(UserPermission.UserSelfUpdate);
  const permissionAdminUserCreate = usePermission(UserPermission.AdminUserCreate);

  return (
    <div>
      <Grid container>
        <Grid item xs={6}>
          <div className={classes.leftText}>Imię i nazwisko</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>
            {props.firstName} {props.lastName}
          </div>
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>PESEL</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>{props.pesel}</div>
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Nr telefonu</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>{props.phone ? formatPhone(props.phone) : ''}</div>
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>E-mail</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>{props.email}</div>
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Komisja</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>{props.committee}</div>
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Typ konta</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>{props.accountTypeName}</div>
        </Grid>

        <hr className={classes.line}></hr>
      </Grid>
      <CancelButton
        onClick={props.editData}
        disabled={
          !permissionUseSelfUpdate &&
          !permissionAdminUserCreate
        }
      >
        Edytuj dane
      </CancelButton>
    </div>
  );
}
